import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
  ExitToApp as LogoutIcon,
  KeyboardArrowDown as ArrowDownIcon,
  Dashboard as DashboardIcon,
  Assignment as LocacaoIcon,
  Handyman as EquipamentoIcon,
  RequestQuote as OrcamentoIcon,
  BusinessCenter as ServicosIcon,
  Groups as ClientesIcon,
  AttachMoney as FinanceiroIcon,
  Store as LojasIcon,
  Description as ContratosIcon,
  AdminPanelSettings as AdminIcon,
  CheckCircle as VigenteIcon,
  History as EncerradaIcon,
} from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";
import logo from "../../../img/logo.png";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutDialogOpen: false,
      anchorElLocacoes: null,
      master: undefined,
    };
  }

  componentDidMount() {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        this.setState({ master: decoded.role });
      } catch (err) {
        console.error("Erro ao decodificar token", err);
      }
    }
  }

  handleOpenMenu = (event) => {
    this.setState({ anchorElLocacoes: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ anchorElLocacoes: null });
  };

  handleLogout = () => {
    window.localStorage.clear();
    window.location.href = "/";
  };

  navButtonStyle = {
    color: "white",
    mx: 0.3,
    fontSize: "0.75rem", // Reduzido levemente para caber com ícones
    textTransform: "none",
    display: "flex",
    flexDirection: "column", // Ícone em cima do texto (estilo moderno) ou deixe vazio para lado a lado
    "&.active": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
    },
    "& .MuiButton-startIcon": {
      margin: 0, // Ajuste se usar flexDirection column
    },
  };

  render() {
    const { master, logoutDialogOpen, anchorElLocacoes } = this.state;
    const isMaster = master === "master";

    return (
      <AppBar
        position="sticky"
        sx={{ backgroundColor: "#282828", boxShadow: 3 }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box
              component={Link}
              to="/"
              sx={{ display: "flex", alignItems: "center", mr: 2 }}
            >
              <img src={logo} alt="Logo" style={{ height: "30px" }} />
            </Box>

            <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
              <Button
                component={NavLink}
                to="/painel-adm"
                sx={this.navButtonStyle}
                startIcon={<DashboardIcon />}
              >
                Painel ADM
              </Button>

              <Button
                sx={this.navButtonStyle}
                onClick={this.handleOpenMenu}
                startIcon={<LocacaoIcon />}
                endIcon={<ArrowDownIcon />}
              >
                Locações
              </Button>
              <Menu
                anchorEl={anchorElLocacoes}
                open={Boolean(anchorElLocacoes)}
                onClose={this.handleCloseMenu}
              >
                <MenuItem
                  onClick={this.handleCloseMenu}
                  component={Link}
                  to="/"
                >
                  <VigenteIcon
                    sx={{ mr: 1, fontSize: 20, color: "success.main" }}
                  />{" "}
                  Vigentes
                </MenuItem>
                <MenuItem
                  onClick={this.handleCloseMenu}
                  component={Link}
                  to="/lease-history"
                >
                  <EncerradaIcon
                    sx={{ mr: 1, fontSize: 20, color: "text.secondary" }}
                  />{" "}
                  Encerradas
                </MenuItem>
              </Menu>

              <Button
                component={NavLink}
                to="/equipamentos"
                sx={this.navButtonStyle}
                startIcon={<EquipamentoIcon />}
              >
                Equipamentos
              </Button>

              <Button
                component={NavLink}
                to="/budget"
                sx={this.navButtonStyle}
                startIcon={<OrcamentoIcon />}
              >
                Orçamentos
              </Button>

              <Button
                component={NavLink}
                to="/services"
                sx={this.navButtonStyle}
                startIcon={<ServicosIcon />}
              >
                Serviços
              </Button>

              <Button
                component={NavLink}
                to="/cadastro-clientes"
                sx={this.navButtonStyle}
                startIcon={<ClientesIcon />}
              >
                Clientes
              </Button>

              {isMaster && (
                <>
                  <Box
                    sx={{
                      height: "30px",
                      width: "1px",
                      bgcolor: "rgba(255,255,255,0.2)",
                      mx: 1,
                    }}
                  />

                  <Button
                    component={NavLink}
                    to="/vendas"
                    sx={this.navButtonStyle}
                    startIcon={<FinanceiroIcon />}
                  >
                    Vendas
                  </Button>

                  <Button
                    component={NavLink}
                    to="/financeiro"
                    sx={this.navButtonStyle}
                    startIcon={<FinanceiroIcon />}
                  >
                    Financeiro
                  </Button>

                  <Button
                    component={NavLink}
                    to="/stores"
                    sx={this.navButtonStyle}
                    startIcon={<LojasIcon />}
                  >
                    Lojas
                  </Button>

                  <Button
                    component={NavLink}
                    to="/contracts"
                    sx={this.navButtonStyle}
                    startIcon={<ContratosIcon />}
                  >
                    Contratos
                  </Button>

                  <Button
                    component={NavLink}
                    to="/admin"
                    sx={{ ...this.navButtonStyle, color: "#ff9800" }}
                    startIcon={<AdminIcon />}
                  >
                    Admin
                  </Button>
                </>
              )}
            </Box>

            <Tooltip title="Sair">
              <IconButton
                color="inherit"
                onClick={() => this.setState({ logoutDialogOpen: true })}
                sx={{ ml: 1, "&:hover": { color: "#f44336" } }}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Toolbar>
        </Container>

        <Dialog
          open={logoutDialogOpen}
          onClose={() => this.setState({ logoutDialogOpen: false })}
        >
          <DialogTitle>Atenção</DialogTitle>
          <DialogContent>
            <Typography>Deseja realmente encerrar a sessão?</Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ logoutDialogOpen: false })}>
              Cancelar
            </Button>
            <Button
              onClick={this.handleLogout}
              color="error"
              variant="contained"
            >
              Sair
            </Button>
          </DialogActions>
        </Dialog>
      </AppBar>
    );
  }
}

export default Header;
